import { Component, inject, input } from '@angular/core';
import { ConfigurationService } from '@core/services';
import { DvmService } from '@features/digital-venue/services/dvm.service';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  selector: 'app-tutorial-welcome-modal',
  templateUrl: './tutorial-welcome-modal.component.html',
  styleUrls: ['./tutorial-welcome-modal.component.css'],
  standalone: false,
})
export class TutorialWelcomeModalComponent {
  readonly title = input<string | undefined>(undefined);
  readonly content = input<string | undefined>(undefined);
  readonly closeBtnName = input<string | undefined>(undefined);
  readonly acceptBtnName = input<string | undefined>(undefined);
  readonly closeFunction = input<(() => void) | undefined>(undefined);
  readonly acceptFunction = input<(() => void) | undefined>(undefined);

  // Legend
  availableColor: string = 'main-light';
  mySeatsColor: string = 'red';
  selectedColor: string = 'purple';
  isolatedColor: string = 'orange';

  get isTopview() {
    return this.dvmService.isTopview;
  }

  private dialogRef = inject(BrnDialogRef);
  configurationService = inject(ConfigurationService);
  private dvmService = inject(DvmService);

  accept() {
    this.dialogRef.close();
    const fn = this.acceptFunction();
    if (fn) {
      fn();
    }
  }

  close() {
    this.dialogRef.close();
    const fn = this.closeFunction();
    if (fn) {
      fn();
    }
  }
}
